import React, { memo, useEffect, useState } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokNode } from '../../interfaces/StoryblokNode.interface';
import { StoryblokPartnerSite } from '../../interfaces/StoryblokPartnerSite.interface';
import { getQueryParam } from '../../utils/getQueryParam/getQueryParam.util';
import NumberedList from '../NumberedList/NumberedList';
import NumberedListBlokProps from '../NumberedList/NumberedList.interface';

interface NextStepsProps {
  dynamic_lists: NumberedListBlokProps[];
}

interface NextSteps extends Blok {
  blok: NextStepsProps;
  children: React.ReactNode;
}

const NextSteps: React.FC<NextSteps> = ({ blok: { dynamic_lists }, blok }) => {
  //   const { partner_sites } = useContext(QuoteStageContext);
  const [partnerSite, setPartnerSite] =
    useState<StoryblokNode<StoryblokPartnerSite>>();

  const quoteReference = getQueryParam('quotation')?.substring(0, 7);

  useEffect(() => {
    if (quoteReference) {
      const partnerSite = dynamic_lists.find((list) =>
        list.partners.find(
          (partner) => partner.content.api_id === quoteReference
        )
      );
      partnerSite &&
        setPartnerSite(
          partnerSite as unknown as StoryblokNode<StoryblokPartnerSite>
        );
    }
  }, []);

  return (
    <section>
      {dynamic_lists.map((list) => {
        const isPartnerSelectedOnList = list.partners.find(
          (partner) => partner.content.api_id === quoteReference
        );
        if (isPartnerSelectedOnList) {
          return <NumberedList {...list} />;
        } else if (!partnerSite && list.is_default) {
          return <NumberedList {...list} />;
        }
      })}
    </section>
  );
};

export default memo(NextSteps);
